import { createWebHistory, createRouter } from 'vue-router'

const routes = [
    { 
        path: '/', 
        component: () => import('@/pages/PageMainSite.vue'), 
        name: 'PageMainSite' 
    },
    // { 
    //     path: '/blog', 
    //     component: () => import('@/pages/PageBlog.vue'), 
    //     name: 'PageBlog',
    //     children: [
    //         { 
    //             path: '', 
    //             component: () => import('@/components/Blog/pages/MainPage.vue'), 
    //             name: 'PageBlogMain' 
    //         },
    //         { 
    //             path: 'article/:id',
    //             component: () => import('@/components/Blog/pages/ArticlePage.vue'), 
    //             name: 'PageBlogArticle' 
    //         },
    //         {
    //             path: 'md-editor',
    //             component: () => import('@/components/Blog/pages/MdEditor.vue')
    //         }
    //     ]
    // },
    { 
        path: '/privacy-policy', 
        component: () => import('@/pages/PagePoliticPrivacy.vue'), 
        name: 'PagePoliticPrivacy' 
    },
    { 
        path: '/personal-data-consent', 
        component: () => import('@/pages/PageDataConsent.vue'), 
        name: 'PageDataConsent' 
    },
    { 
        path: '/:pathMatch(.*)*', 
        redirect: { name: 'PageMainSite' } 
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

export default router